import React, {Component} from 'react'
import benefit1 from "../../../../images/index_popup/benefit-cameras1.png";
import benefit2 from "../../../../images/index_popup/benefit-cameras2.png";
import benefit3 from "../../../../images/index_popup/benefit-cameras3.png";
import benefit4 from "../../../../images/index_popup/benefit-cameras4.png";
import qr from "../../../../images/index_popup/qr.svg";
import banner from "../../../../images/index_popup/banner-cameras.png";

export default class CamerasApplicationBanner extends Component {
    constructor(props) {
        super(props);
        this.processDownloadButtonClick = props.popupLinkCallback
    }


    render() {
        return (
            <div className="d-flex popup-container">
                <div className={'popup-pc__content-text'}>
                    <div className="benefits-container">
                        <div className={'popup-pc__content-text__header'}><b>Больше камер в приложении</b><br/>
                            «Ситилинк. Дом в телефоне»
                        </div>
                        <div
                            className={'popup-pc__content-text__benefits'}>
                            <img className={'popup-pc__content-text__benefits__img'} src={benefit1} alt=""/>
                            <b>Смотрите городские камеры</b> и их архив.
                        </div>
                        <div className={'popup-pc__content-text__benefits'}>
                            <img className={'popup-pc__content-text__benefits__img'} src={benefit2} alt=""/>
                            Получайте <b>доступ к дворовым</b> камерам.
                        </div>
                        <div className={'popup-pc__content-text__benefits'}>
                            <img className={'popup-pc__content-text__benefits__img'} src={benefit3} alt=""/>
                            Добавляйте камеры в избранное.
                        </div>
                        <div className={'popup-pc__content-text__benefits'}>
                            <img className={'popup-pc__content-text__benefits__img'} src={benefit4} alt=""/>
                            Ставьте <b>транспорт под наблюдение.</b>
                        </div>
                        <div className={'popup-pc__content-text__btns d-flex'}>
                            <input type="button"
                                   className="popup-pc__content-text__btns__btn-send-request"
                                   onClick={() => this.processDownloadButtonClick("https://v2.smarthome.citylink.pro/get_app?q=md_banner2")}
                                   value="Скачать прямо сейчас"/><br/>
                            <img width="107" height="107" className={'only-pc'} src={qr} alt=""/>
                        </div>
                    </div>

                </div>
                <div className="popup-pc__picture">
                    <picture>
                        <source srcSet={banner} type="image/png"/>
                        <img src={banner} alt=""/>
                    </picture>
                </div>
            </div>
        )
    }
}